// Chèque
export const CHEQUE = 'Chèque';
// Numéraire
export const NUMERAIRE = 'Numéraire';
// Carte bancaire
export const CARTE_BANCAIRE = 'Carte bancaire';
// CESU
export const CESU = 'CESU';
// Chèque vacances
export const CHEQUE_VAC = 'Chèque vacances';
// Bon CCAS
export const BON_CCAS = 'Bon CCAS';
// Bon CAF
export const BON_CAF = 'Bon CAF';
// Tickets
export const TICKET = 'Tickets';
// Virement
export const VIREMENT = 'Virement';
// Prélèvement
export const PRELEVEMENT = 'Prélèvement';
// Carte bancaire par internet
export const CARTE_BANCAIRE_INTERNET = 'Carte bancaire par internet';
// Prélèvement par internet
export const PRELEVEMENT_INTERNET = 'Prélèvement par internet';
// Règlement interne
export const REGLEMENT_INTERNE = 'Règlement interne';
